// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"d64120d049c1114d","931":"37d458ca34876beb"}[chunkId] + ".css";
};